module.exports = __webpack_public_path__ + "img/phonecall_icon.47d210b6.svg";